import React from 'react';
import { TartaWordmark } from './TartaWordmark';
import { useLanguage } from '../context/LanguageContext';
// Footer utility links, in the same order as t.footer.links
// (Privacy Policy, Terms & Conditions, Contact).
const LINK_HREFS = ['#faq', '#faq', 'mailto:tarta@tartahtx.com'];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-espresso text-cream/60 pt-24 pb-12 border-t border-cream/5" data-id="element-129" data-mp="36ppnjusnikg7">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-130" data-mp="3ufjyu7xbo0yc">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-10 pb-16 border-b border-cream/10" data-id="element-131" data-mp="38za4uuqp54h">
          <div className="lg:col-span-5 text-cream" data-id="element-132" data-mp="3ldan5eqbi1jd">
            <TartaWordmark height={26} data-id="element-133" data-mp="3lgosmvua2qv1" />
            <p className="mt-3 text-[10px] tracking-[0.4em] uppercase text-cream/50" data-id="element-134" data-mp="3qcdsl0a7m9rv">
              {t.footer.tagline}
            </p>
            <p className="mt-10 font-serif italic text-cream/50 text-lg max-w-sm leading-[1.5]" data-id="element-135" data-mp="29xvqyd5xndpb">
              {t.footer.quote}
            </p>
          </div>
          <div className="lg:col-span-3" data-id="element-136" data-mp="3l8qx26bccnsi">
            <p className="text-[10px] tracking-[0.3em] uppercase text-caramel mb-5" data-id="element-137" data-mp="3lbmt1p3mp2eb">
              {t.footer.origin}
            </p>
            <p className="text-[14px]" data-id="element-138" data-mp="3v7gg42ez4eac">{t.footer.originValue}</p>
            <p className="text-[14px] text-cream/40 mt-1" data-id="element-139" data-mp="3v5n5yd55jbxl">
              {t.footer.originSub}
            </p>
          </div>
          <div className="lg:col-span-4" data-id="element-140" data-mp="830j3ija450h">
            <p className="text-[10px] tracking-[0.3em] uppercase text-caramel mb-5" data-id="element-141" data-mp="81pghm1kl3ay">
              {t.footer.follow}
            </p>
            <a href="mailto:tarta@tartahtx.com" className="block text-[14px] hover:text-caramel transition-colors duration-500" data-id="element-142" data-mp="31uo1e25c5ns">
              {t.footer.email}
            </a>
            <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="block mt-2 text-[14px] hover:text-caramel transition-colors duration-500" data-id="element-143" data-mp="qthy6kb6v23d">
              @tartahtx
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-6 sm:items-center sm:justify-between" data-id="element-144" data-mp="yty0jtkm8t4n">
          <div className="flex flex-wrap gap-x-8 gap-y-2 text-[10px] tracking-[0.3em] uppercase text-cream/40" data-id="element-145" data-mp="13tkclzopk3bv">
            {t.footer.links.map((link, i) => <a key={link} href={LINK_HREFS[i] ?? '#top'} className="hover:text-caramel transition-colors duration-500" data-id="element-146" data-mp="18lbvrp5jb6rz" data-mpi={i}>
                {link}
              </a>)}
          </div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-cream/30" data-id="element-147" data-mp="1mjijwdkolseg">
            © 2025 {t.footer.copyright}
          </p>
        </div>

        <p className="mt-8 text-[10px] tracking-[0.3em] uppercase text-cream/25" data-id="element-148" data-mp="1rgsiojtyngey">
          {t.footer.crafted}
        </p>
      </div>
    </footer>;
}